var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.65 6.792a3.654 3.654 0 0 1-3.65 3.65 3.66 3.66 0 0 1-3.65-3.65A3.66 3.66 0 0 1 10 3.142a3.66 3.66 0 0 1 3.65 3.65Zm-1.25 0a2.4 2.4 0 1 0-4.801 0 2.4 2.4 0 0 0 4.801 0ZM10 10.9c3.084 0 5.883 1.642 7.492 4.383h.017c.183.325.183.725 0 1.05a1.013 1.013 0 0 1-.9.525h-13.2c-.375 0-.709-.2-.9-.525a1.03 1.03 0 0 1 0-1.05C4.109 12.542 6.917 10.9 10 10.9Zm-.008 1.25c-2.517 0-4.817 1.292-6.225 3.458h12.45c-1.4-2.175-3.708-3.458-6.225-3.458Z",
    fill: "current"
  })));
};
export default SvgUser;